var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.disabled)?_c('div',{staticClass:"focus-trap-first",attrs:{"tabindex":"0"},on:{"focus":_vm.handleFirstTrapFocus}}):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),(!_vm.disabled)?_c('div',{staticClass:"focus-trap-last",attrs:{"tabindex":"0"},on:{"focus":_vm.handleLastTrapFocus}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }